import { render, staticRenderFns } from "./FamilleProduit.vue?vue&type=template&id=11fbe9ae"
import script from "./FamilleProduit.vue?vue&type=script&lang=js"
export * from "./FamilleProduit.vue?vue&type=script&lang=js"
import style0 from "./FamilleProduit.vue?vue&type=style&index=0&id=11fbe9ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports